/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { FastprisaftaleCreateDto as OkEgisServiceModelsDtoFastprisaftaleCreateDto } from '../models/OK/Egis/Service/Models/DTO/fastprisaftale-create-dto';
import { FastprisaftaleDto as OkEgisServiceModelsDtoFastprisaftaleDto } from '../models/OK/Egis/Service/Models/DTO/fastprisaftale-dto';
import { FastprisaftaleUpdateDto as OkEgisServiceModelsDtoFastprisaftaleUpdateDto } from '../models/OK/Egis/Service/Models/DTO/fastprisaftale-update-dto';

@Injectable({
  providedIn: 'root',
})
export class FastprisaftaleService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation create
   */
  static readonly CreatePath = '/api/v1/Fastprisaftale/Create';

  /**
   * Creates Fastprisaftale.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoFastprisaftaleCreateDto
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoFastprisaftaleDto>> {

    const rb = new RequestBuilder(this.rootUrl, FastprisaftaleService.CreatePath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoFastprisaftaleDto>;
      })
    );
  }

  /**
   * Creates Fastprisaftale.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoFastprisaftaleCreateDto
  }): Observable<OkEgisServiceModelsDtoFastprisaftaleDto> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoFastprisaftaleDto>) => r.body as OkEgisServiceModelsDtoFastprisaftaleDto)
    );
  }

  /**
   * Path part for operation getAllByServiceaftaleId
   */
  static readonly GetAllByServiceaftaleIdPath = '/api/v1/Fastprisaftale/GetAllByServiceaftaleId';

  /**
   * Lists all Fastprisaftaler related to a serviceaftale.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllByServiceaftaleId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllByServiceaftaleId$Response(params: {
    serviceaftaleId?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoFastprisaftaleDto>>> {

    const rb = new RequestBuilder(this.rootUrl, FastprisaftaleService.GetAllByServiceaftaleIdPath, 'get');
    if (params) {
      rb.query('serviceaftaleId', params.serviceaftaleId, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoFastprisaftaleDto>>;
      })
    );
  }

  /**
   * Lists all Fastprisaftaler related to a serviceaftale.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAllByServiceaftaleId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllByServiceaftaleId(params: {
    serviceaftaleId?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoFastprisaftaleDto>> {

    return this.getAllByServiceaftaleId$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoFastprisaftaleDto>>) => r.body as Array<OkEgisServiceModelsDtoFastprisaftaleDto>)
    );
  }

  /**
   * Path part for operation delete
   */
  static readonly DeletePath = '/api/v1/Fastprisaftale/Delete';

  /**
   * Deletes a Fastprisaftale.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `delete()` instead.
   *
   * This method doesn't expect any request body.
   */
  delete$Response(params: {
    fastprisaftaleId?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoFastprisaftaleDto>>> {

    const rb = new RequestBuilder(this.rootUrl, FastprisaftaleService.DeletePath, 'delete');
    if (params) {
      rb.query('fastprisaftaleId', params.fastprisaftaleId, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoFastprisaftaleDto>>;
      })
    );
  }

  /**
   * Deletes a Fastprisaftale.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `delete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  delete(params: {
    fastprisaftaleId?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoFastprisaftaleDto>> {

    return this.delete$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoFastprisaftaleDto>>) => r.body as Array<OkEgisServiceModelsDtoFastprisaftaleDto>)
    );
  }

  /**
   * Path part for operation update
   */
  static readonly UpdatePath = '/api/v1/Fastprisaftale/Update';

  /**
   * Updates Fastprisaftale.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `update()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  update$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoFastprisaftaleUpdateDto
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoFastprisaftaleDto>> {

    const rb = new RequestBuilder(this.rootUrl, FastprisaftaleService.UpdatePath, 'put');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoFastprisaftaleDto>;
      })
    );
  }

  /**
   * Updates Fastprisaftale.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `update$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  update(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoFastprisaftaleUpdateDto
  }): Observable<OkEgisServiceModelsDtoFastprisaftaleDto> {

    return this.update$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoFastprisaftaleDto>) => r.body as OkEgisServiceModelsDtoFastprisaftaleDto)
    );
  }

}
